import { IAxios } from "../conf";

const baseEndpoint = "InventarioProductoLog/";

const GetInventarioProductoLogList = async () => {
  return await IAxios.get(baseEndpoint);
};

const GetInventarioProductoLog = async (
  idInventarioProductoLog
) => {
  const endpoint = baseEndpoint + idInventarioProductoLog;
  return await IAxios.get(endpoint);
};

const PostInventarioProductoLog = async (inventarioProductoLog) => {
  return await IAxios.post(baseEndpoint, inventarioProductoLog);
};

const ApiInventarioProductoLog = {
  GetInventarioProductoLogList,
  GetInventarioProductoLog,
  PostInventarioProductoLog,
};

export default ApiInventarioProductoLog;
